var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapa5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.650024 7.65407V14.5033H16.9659V7.65407C16.9659 6.95636 16.4002 6.38869 15.7005 6.38869H1.91541C1.21769 6.38869 0.650024 6.95429 0.650024 7.65407Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74878 10.1187H2.4563",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56292 14.7447C5.56292 15.7975 4.71039 16.65 3.65762 16.65C2.60485 16.65 1.75232 15.7975 1.75232 14.7447C1.75232 14.6622 1.75851 14.5816 1.76883 14.5032H5.54641C5.5588 14.5816 5.56292 14.6622 5.56292 14.7447Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7459 14.7447C15.7459 15.7975 14.8934 16.65 13.8406 16.65C12.7878 16.65 11.9353 15.7975 11.9353 14.7447C11.9353 14.6622 11.9394 14.5816 11.9518 14.5032H15.7294C15.7418 14.5816 15.7459 14.6622 15.7459 14.7447Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74878 10.1187H2.4563",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8806 0.649994H13.6631C14.3257 0.649994 14.8624 1.18876 14.8624 1.84932V6.37209H2.68127V1.84932C2.68127 1.1867 3.22004 0.649994 3.8806 0.649994Z",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9884 10.1187H11.6959",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9884 10.1187H11.6959",
    stroke: "#1A1C40",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa5);
export default __webpack_public_path__ + "static/media/Capa 5.ba51ff9e603969498398b523b3054489.svg";
export { ForwardRef as ReactComponent };